export default function onMapIdle(map: google.maps.Map): Promise<void> {
    return new Promise(resolve => {
        const listener = google.maps.event.addListener(map, 'idle', () => {
            google.maps.event.removeListener(listener);

            resolve();
        });
    });
}
